module.exports = __webpack_public_path__ + "static/media/thumbnail-example.5b2cca31.png";